export type FieldType = 'string' | 'number' | 'date'

export interface DatasetField {
  key: string
  label: string
  type: FieldType
}

export interface Dataset {
  id: string
  name: string
  description: string
  fields: DatasetField[]
  rows: Record<string, string | number>[]
}

export const datasets: Dataset[] = [
  {
    id: 'appointments',
    name: 'Appointments',
    description:
      'Scheduled and completed testing appointments with booking details.',
    fields: [
      { key: 'id', label: 'Appt ID', type: 'string' },
      { key: 'participant', label: 'Participant', type: 'string' },
      { key: 'company', label: 'Company', type: 'string' },
      { key: 'testType', label: 'Test Type', type: 'string' },
      { key: 'bookingMethod', label: 'Booking Method', type: 'string' },
      { key: 'bookingAgent', label: 'Booking Agent', type: 'string' },
      { key: 'collectionSite', label: 'Collection Site', type: 'string' },
      { key: 'status', label: 'Status', type: 'string' },
      { key: 'apptDate', label: 'Appointment Date', type: 'date' },
      { key: 'leadTimeDays', label: 'Lead Time (Days)', type: 'number' },
    ],
    rows: [
      {
        id: 'AP-10241',
        participant: 'D. Kowalski',
        company: 'Northbridge Energy',
        testType: 'Urine Drug Test',
        bookingMethod: 'Online Portal',
        bookingAgent: 'S. Chen',
        collectionSite: 'Edmonton North',
        status: 'Completed',
        apptDate: '2026-06-02',
        leadTimeDays: 2,
      },
      {
        id: 'AP-10242',
        participant: 'M. Tremblay',
        company: 'Cascade Constructors',
        testType: 'Breath Alcohol',
        bookingMethod: 'Phone',
        bookingAgent: 'R. Patel',
        collectionSite: 'Calgary South',
        status: 'Completed',
        apptDate: '2026-06-03',
        leadTimeDays: 1,
      },
      {
        id: 'AP-10243',
        participant: 'J. Whitehorse',
        company: 'Prairie Rail Co',
        testType: 'Audiometric',
        bookingMethod: 'Online Portal',
        bookingAgent: 'S. Chen',
        collectionSite: 'Saskatoon Central',
        status: 'No Show',
        apptDate: '2026-06-03',
        leadTimeDays: 4,
      },
      {
        id: 'AP-10244',
        participant: 'A. Fontaine',
        company: 'Summit Mining Group',
        testType: 'Fit for Duty',
        bookingMethod: 'SureConnect',
        bookingAgent: 'T. Nguyen',
        collectionSite: 'Fort McMurray',
        status: 'Completed',
        apptDate: '2026-06-04',
        leadTimeDays: 3,
      },
      {
        id: 'AP-10245',
        participant: 'K. Osei',
        company: 'TransWest Logistics',
        testType: 'Urine Drug Test',
        bookingMethod: 'Phone',
        bookingAgent: 'R. Patel',
        collectionSite: 'Winnipeg West',
        status: 'Rescheduled',
        apptDate: '2026-06-05',
        leadTimeDays: 2,
      },
      {
        id: 'AP-10246',
        participant: 'L. Bergeron',
        company: 'Northbridge Energy',
        testType: 'Spirometry',
        bookingMethod: 'Online Portal',
        bookingAgent: 'M. Dubois',
        collectionSite: 'Edmonton North',
        status: 'Completed',
        apptDate: '2026-06-08',
        leadTimeDays: 5,
      },
      {
        id: 'AP-10247',
        participant: 'S. Cardinal',
        company: 'Prairie Rail Co',
        testType: 'Urine Drug Test',
        bookingMethod: 'SureConnect',
        bookingAgent: 'T. Nguyen',
        collectionSite: 'Regina East',
        status: 'Completed',
        apptDate: '2026-06-09',
        leadTimeDays: 1,
      },
      {
        id: 'AP-10248',
        participant: 'P. Iverson',
        company: 'Cascade Constructors',
        testType: 'Breath Alcohol',
        bookingMethod: 'Phone',
        bookingAgent: 'S. Chen',
        collectionSite: 'Calgary South',
        status: 'Cancelled',
        apptDate: '2026-06-10',
        leadTimeDays: 3,
      },
      {
        id: 'AP-10249',
        participant: 'N. Villeneuve',
        company: 'Summit Mining Group',
        testType: 'Fit for Duty',
        bookingMethod: 'Online Portal',
        bookingAgent: 'M. Dubois',
        collectionSite: 'Fort McMurray',
        status: 'Completed',
        apptDate: '2026-06-11',
        leadTimeDays: 2,
      },
      {
        id: 'AP-10250',
        participant: 'G. Thunderchild',
        company: 'TransWest Logistics',
        testType: 'Audiometric',
        bookingMethod: 'SureConnect',
        bookingAgent: 'R. Patel',
        collectionSite: 'Winnipeg West',
        status: 'Completed',
        apptDate: '2026-06-12',
        leadTimeDays: 6,
      },
      {
        id: 'AP-10251',
        participant: 'H. Lindqvist',
        company: 'Northbridge Energy',
        testType: 'Urine Drug Test',
        bookingMethod: 'Online Portal',
        bookingAgent: 'S. Chen',
        collectionSite: 'Edmonton North',
        status: 'Completed',
        apptDate: '2026-06-15',
        leadTimeDays: 2,
      },
      {
        id: 'AP-10252',
        participant: 'F. Okafor',
        company: 'Prairie Rail Co',
        testType: 'Spirometry',
        bookingMethod: 'Phone',
        bookingAgent: 'T. Nguyen',
        collectionSite: 'Saskatoon Central',
        status: 'Rescheduled',
        apptDate: '2026-06-16',
        leadTimeDays: 4,
      },
      {
        id: 'AP-10253',
        participant: 'C. Beaulieu',
        company: 'Cascade Constructors',
        testType: 'Urine Drug Test',
        bookingMethod: 'SureConnect',
        bookingAgent: 'M. Dubois',
        collectionSite: 'Calgary South',
        status: 'Completed',
        apptDate: '2026-06-17',
        leadTimeDays: 1,
      },
      {
        id: 'AP-10254',
        participant: 'R. Yellowbird',
        company: 'Summit Mining Group',
        testType: 'Breath Alcohol',
        bookingMethod: 'Online Portal',
        bookingAgent: 'S. Chen',
        collectionSite: 'Fort McMurray',
        status: 'Completed',
        apptDate: '2026-06-18',
        leadTimeDays: 3,
      },
      {
        id: 'AP-10255',
        participant: 'E. Sokolov',
        company: 'TransWest Logistics',
        testType: 'Fit for Duty',
        bookingMethod: 'Phone',
        bookingAgent: 'R. Patel',
        collectionSite: 'Winnipeg West',
        status: 'No Show',
        apptDate: '2026-06-19',
        leadTimeDays: 5,
      },
      {
        id: 'AP-10256',
        participant: 'B. Martineau',
        company: 'Northbridge Energy',
        testType: 'Audiometric',
        bookingMethod: 'SureConnect',
        bookingAgent: 'T. Nguyen',
        collectionSite: 'Edmonton North',
        status: 'Completed',
        apptDate: '2026-06-22',
        leadTimeDays: 2,
      },
      {
        id: 'AP-10257',
        participant: 'W. Halverson',
        company: 'Prairie Rail Co',
        testType: 'Urine Drug Test',
        bookingMethod: 'Online Portal',
        bookingAgent: 'M. Dubois',
        collectionSite: 'Regina East',
        status: 'Completed',
        apptDate: '2026-06-23',
        leadTimeDays: 1,
      },
      {
        id: 'AP-10258',
        participant: 'T. Abernathy',
        company: 'Cascade Constructors',
        testType: 'Spirometry',
        bookingMethod: 'Phone',
        bookingAgent: 'S. Chen',
        collectionSite: 'Calgary South',
        status: 'Completed',
        apptDate: '2026-06-24',
        leadTimeDays: 4,
      },
      {
        id: 'AP-10259',
        participant: 'V. Nakamura',
        company: 'Summit Mining Group',
        testType: 'Urine Drug Test',
        bookingMethod: 'SureConnect',
        bookingAgent: 'R. Patel',
        collectionSite: 'Fort McMurray',
        status: 'Completed',
        apptDate: '2026-06-25',
        leadTimeDays: 2,
      },
      {
        id: 'AP-10260',
        participant: 'O. Ferreira',
        company: 'TransWest Logistics',
        testType: 'Breath Alcohol',
        bookingMethod: 'Online Portal',
        bookingAgent: 'T. Nguyen',
        collectionSite: 'Winnipeg West',
        status: 'Completed',
        apptDate: '2026-06-26',
        leadTimeDays: 3,
      },
      {
        id: 'AP-10261',
        participant: 'I. MacPherson',
        company: 'Northbridge Energy',
        testType: 'Fit for Duty',
        bookingMethod: 'Phone',
        bookingAgent: 'M. Dubois',
        collectionSite: 'Edmonton North',
        status: 'Completed',
        apptDate: '2026-06-29',
        leadTimeDays: 1,
      },
      {
        id: 'AP-10262',
        participant: 'Y. Desjardins',
        company: 'Prairie Rail Co',
        testType: 'Urine Drug Test',
        bookingMethod: 'SureConnect',
        bookingAgent: 'S. Chen',
        collectionSite: 'Saskatoon Central',
        status: 'Rescheduled',
        apptDate: '2026-06-30',
        leadTimeDays: 2,
      },
      {
        id: 'AP-10263',
        participant: 'Q. Antoine',
        company: 'Cascade Constructors',
        testType: 'Audiometric',
        bookingMethod: 'Online Portal',
        bookingAgent: 'R. Patel',
        collectionSite: 'Calgary South',
        status: 'Completed',
        apptDate: '2026-07-02',
        leadTimeDays: 3,
      },
      {
        id: 'AP-10264',
        participant: 'Z. Grewal',
        company: 'Summit Mining Group',
        testType: 'Urine Drug Test',
        bookingMethod: 'Phone',
        bookingAgent: 'T. Nguyen',
        collectionSite: 'Fort McMurray',
        status: 'Completed',
        apptDate: '2026-07-03',
        leadTimeDays: 2,
      },
    ],
  },
  {
    id: 'results',
    name: 'Test Results',
    description: 'Lab-confirmed test outcomes with turnaround metrics.',
    fields: [
      { key: 'id', label: 'Result ID', type: 'string' },
      { key: 'participant', label: 'Participant', type: 'string' },
      { key: 'company', label: 'Company', type: 'string' },
      { key: 'testCategory', label: 'Test Category', type: 'string' },
      { key: 'result', label: 'Result', type: 'string' },
      { key: 'lab', label: 'Laboratory', type: 'string' },
      { key: 'collectedDate', label: 'Collected Date', type: 'date' },
      { key: 'turnaroundHrs', label: 'Turnaround (Hrs)', type: 'number' },
    ],
    rows: [
      {
        id: 'RS-88101',
        participant: 'D. Kowalski',
        company: 'Northbridge Energy',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-02',
        turnaroundHrs: 26,
      },
      {
        id: 'RS-88102',
        participant: 'M. Tremblay',
        company: 'Cascade Constructors',
        testCategory: 'Breath Alcohol',
        result: 'Negative',
        lab: 'On-Site',
        collectedDate: '2026-06-03',
        turnaroundHrs: 1,
      },
      {
        id: 'RS-88103',
        participant: 'A. Fontaine',
        company: 'Summit Mining Group',
        testCategory: 'Non-DOT Urine',
        result: 'Non-Negative',
        lab: 'LabCorp Calgary',
        collectedDate: '2026-06-04',
        turnaroundHrs: 48,
      },
      {
        id: 'RS-88104',
        participant: 'K. Osei',
        company: 'TransWest Logistics',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-05',
        turnaroundHrs: 30,
      },
      {
        id: 'RS-88105',
        participant: 'L. Bergeron',
        company: 'Northbridge Energy',
        testCategory: 'Oral Fluid',
        result: 'Negative',
        lab: 'LabCorp Calgary',
        collectedDate: '2026-06-08',
        turnaroundHrs: 22,
      },
      {
        id: 'RS-88106',
        participant: 'S. Cardinal',
        company: 'Prairie Rail Co',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-09',
        turnaroundHrs: 25,
      },
      {
        id: 'RS-88107',
        participant: 'N. Villeneuve',
        company: 'Summit Mining Group',
        testCategory: 'Non-DOT Urine',
        result: 'Positive',
        lab: 'LabCorp Calgary',
        collectedDate: '2026-06-11',
        turnaroundHrs: 52,
      },
      {
        id: 'RS-88108',
        participant: 'G. Thunderchild',
        company: 'TransWest Logistics',
        testCategory: 'Oral Fluid',
        result: 'Negative',
        lab: 'On-Site',
        collectedDate: '2026-06-12',
        turnaroundHrs: 20,
      },
      {
        id: 'RS-88109',
        participant: 'H. Lindqvist',
        company: 'Northbridge Energy',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-15',
        turnaroundHrs: 28,
      },
      {
        id: 'RS-88110',
        participant: 'C. Beaulieu',
        company: 'Cascade Constructors',
        testCategory: 'Breath Alcohol',
        result: 'Negative',
        lab: 'On-Site',
        collectedDate: '2026-06-17',
        turnaroundHrs: 1,
      },
      {
        id: 'RS-88111',
        participant: 'R. Yellowbird',
        company: 'Summit Mining Group',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-18',
        turnaroundHrs: 24,
      },
      {
        id: 'RS-88112',
        participant: 'B. Martineau',
        company: 'Northbridge Energy',
        testCategory: 'Oral Fluid',
        result: 'Cancelled',
        lab: 'LabCorp Calgary',
        collectedDate: '2026-06-22',
        turnaroundHrs: 12,
      },
      {
        id: 'RS-88113',
        participant: 'W. Halverson',
        company: 'Prairie Rail Co',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-23',
        turnaroundHrs: 27,
      },
      {
        id: 'RS-88114',
        participant: 'T. Abernathy',
        company: 'Cascade Constructors',
        testCategory: 'Non-DOT Urine',
        result: 'Negative',
        lab: 'LabCorp Calgary',
        collectedDate: '2026-06-24',
        turnaroundHrs: 33,
      },
      {
        id: 'RS-88115',
        participant: 'V. Nakamura',
        company: 'Summit Mining Group',
        testCategory: 'DOT Urine',
        result: 'Non-Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-25',
        turnaroundHrs: 46,
      },
      {
        id: 'RS-88116',
        participant: 'O. Ferreira',
        company: 'TransWest Logistics',
        testCategory: 'Breath Alcohol',
        result: 'Negative',
        lab: 'On-Site',
        collectedDate: '2026-06-26',
        turnaroundHrs: 1,
      },
      {
        id: 'RS-88117',
        participant: 'I. MacPherson',
        company: 'Northbridge Energy',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-06-29',
        turnaroundHrs: 29,
      },
      {
        id: 'RS-88118',
        participant: 'Q. Antoine',
        company: 'Cascade Constructors',
        testCategory: 'Oral Fluid',
        result: 'Negative',
        lab: 'LabCorp Calgary',
        collectedDate: '2026-07-02',
        turnaroundHrs: 21,
      },
      {
        id: 'RS-88119',
        participant: 'Z. Grewal',
        company: 'Summit Mining Group',
        testCategory: 'DOT Urine',
        result: 'Negative',
        lab: 'DynaLIFE Edmonton',
        collectedDate: '2026-07-03',
        turnaroundHrs: 26,
      },
      {
        id: 'RS-88120',
        participant: 'Y. Desjardins',
        company: 'Prairie Rail Co',
        testCategory: 'Non-DOT Urine',
        result: 'Negative',
        lab: 'LabCorp Calgary',
        collectedDate: '2026-07-06',
        turnaroundHrs: 31,
      },
    ],
  },
  {
    id: 'surveys',
    name: 'Participant Surveys',
    description: 'Post-appointment satisfaction ratings and comments.',
    fields: [
      { key: 'id', label: 'Survey ID', type: 'string' },
      { key: 'participant', label: 'Participant', type: 'string' },
      { key: 'company', label: 'Company', type: 'string' },
      { key: 'collectionSite', label: 'Collection Site', type: 'string' },
      { key: 'rating', label: 'Rating (1-5)', type: 'number' },
      { key: 'comment', label: 'Comment', type: 'string' },
      { key: 'surveyDate', label: 'Survey Date', type: 'date' },
    ],
    rows: [
      {
        id: 'SV-501',
        participant: 'D. Kowalski',
        company: 'Northbridge Energy',
        collectionSite: 'Edmonton North',
        rating: 5,
        comment: 'Fast and professional.',
        surveyDate: '2026-06-03',
      },
      {
        id: 'SV-502',
        participant: 'M. Tremblay',
        company: 'Cascade Constructors',
        collectionSite: 'Calgary South',
        rating: 4,
        comment: 'Short wait time.',
        surveyDate: '2026-06-04',
      },
      {
        id: 'SV-503',
        participant: 'A. Fontaine',
        company: 'Summit Mining Group',
        collectionSite: 'Fort McMurray',
        rating: 3,
        comment: 'Parking was difficult.',
        surveyDate: '2026-06-05',
      },
      {
        id: 'SV-504',
        participant: 'L. Bergeron',
        company: 'Northbridge Energy',
        collectionSite: 'Edmonton North',
        rating: 5,
        comment: 'Excellent staff.',
        surveyDate: '2026-06-09',
      },
      {
        id: 'SV-505',
        participant: 'S. Cardinal',
        company: 'Prairie Rail Co',
        collectionSite: 'Regina East',
        rating: 4,
        comment: 'Clear instructions.',
        surveyDate: '2026-06-10',
      },
      {
        id: 'SV-506',
        participant: 'N. Villeneuve',
        company: 'Summit Mining Group',
        collectionSite: 'Fort McMurray',
        rating: 2,
        comment: 'Waited 40 minutes.',
        surveyDate: '2026-06-12',
      },
      {
        id: 'SV-507',
        participant: 'G. Thunderchild',
        company: 'TransWest Logistics',
        collectionSite: 'Winnipeg West',
        rating: 5,
        comment: 'Very smooth process.',
        surveyDate: '2026-06-13',
      },
      {
        id: 'SV-508',
        participant: 'H. Lindqvist',
        company: 'Northbridge Energy',
        collectionSite: 'Edmonton North',
        rating: 4,
        comment: 'Friendly technician.',
        surveyDate: '2026-06-16',
      },
      {
        id: 'SV-509',
        participant: 'C. Beaulieu',
        company: 'Cascade Constructors',
        collectionSite: 'Calgary South',
        rating: 5,
        comment: 'In and out in 15 minutes.',
        surveyDate: '2026-06-18',
      },
      {
        id: 'SV-510',
        participant: 'R. Yellowbird',
        company: 'Summit Mining Group',
        collectionSite: 'Fort McMurray',
        rating: 4,
        comment: 'Good communication.',
        surveyDate: '2026-06-19',
      },
      {
        id: 'SV-511',
        participant: 'B. Martineau',
        company: 'Northbridge Energy',
        collectionSite: 'Edmonton North',
        rating: 3,
        comment: 'Booking portal was slow.',
        surveyDate: '2026-06-23',
      },
      {
        id: 'SV-512',
        participant: 'W. Halverson',
        company: 'Prairie Rail Co',
        collectionSite: 'Regina East',
        rating: 5,
        comment: 'Great experience.',
        surveyDate: '2026-06-24',
      },
      {
        id: 'SV-513',
        participant: 'V. Nakamura',
        company: 'Summit Mining Group',
        collectionSite: 'Fort McMurray',
        rating: 4,
        comment: 'On time.',
        surveyDate: '2026-06-26',
      },
      {
        id: 'SV-514',
        participant: 'O. Ferreira',
        company: 'TransWest Logistics',
        collectionSite: 'Winnipeg West',
        rating: 5,
        comment: 'Professional and quick.',
        surveyDate: '2026-06-27',
      },
      {
        id: 'SV-515',
        participant: 'I. MacPherson',
        company: 'Northbridge Energy',
        collectionSite: 'Edmonton North',
        rating: 4,
        comment: 'No issues.',
        surveyDate: '2026-06-30',
      },
      {
        id: 'SV-516',
        participant: 'Q. Antoine',
        company: 'Cascade Constructors',
        collectionSite: 'Calgary South',
        rating: 5,
        comment: 'Best site so far.',
        surveyDate: '2026-07-03',
      },
    ],
  },
  {
    id: 'clearances',
    name: 'Preemptive Clearances',
    description: 'Clearance requests filtered by status, date, and company.',
    fields: [
      { key: 'id', label: 'Clearance ID', type: 'string' },
      { key: 'participant', label: 'Participant', type: 'string' },
      { key: 'company', label: 'Company', type: 'string' },
      { key: 'clearanceType', label: 'Clearance Type', type: 'string' },
      { key: 'status', label: 'Status', type: 'string' },
      { key: 'requestedDate', label: 'Requested Date', type: 'date' },
      { key: 'processingDays', label: 'Processing (Days)', type: 'number' },
    ],
    rows: [
      {
        id: 'PC-3301',
        participant: 'D. Kowalski',
        company: 'Northbridge Energy',
        clearanceType: 'Pre-Access',
        status: 'Cleared',
        requestedDate: '2026-06-01',
        processingDays: 2,
      },
      {
        id: 'PC-3302',
        participant: 'J. Whitehorse',
        company: 'Prairie Rail Co',
        clearanceType: 'Site Entry',
        status: 'Pending',
        requestedDate: '2026-06-02',
        processingDays: 5,
      },
      {
        id: 'PC-3303',
        participant: 'A. Fontaine',
        company: 'Summit Mining Group',
        clearanceType: 'Pre-Access',
        status: 'Cleared',
        requestedDate: '2026-06-04',
        processingDays: 3,
      },
      {
        id: 'PC-3304',
        participant: 'K. Osei',
        company: 'TransWest Logistics',
        clearanceType: 'Return to Duty',
        status: 'Denied',
        requestedDate: '2026-06-05',
        processingDays: 4,
      },
      {
        id: 'PC-3305',
        participant: 'S. Cardinal',
        company: 'Prairie Rail Co',
        clearanceType: 'Pre-Access',
        status: 'Cleared',
        requestedDate: '2026-06-08',
        processingDays: 1,
      },
      {
        id: 'PC-3306',
        participant: 'P. Iverson',
        company: 'Cascade Constructors',
        clearanceType: 'Site Entry',
        status: 'Cleared',
        requestedDate: '2026-06-09',
        processingDays: 2,
      },
      {
        id: 'PC-3307',
        participant: 'N. Villeneuve',
        company: 'Summit Mining Group',
        clearanceType: 'Return to Duty',
        status: 'Pending',
        requestedDate: '2026-06-11',
        processingDays: 6,
      },
      {
        id: 'PC-3308',
        participant: 'H. Lindqvist',
        company: 'Northbridge Energy',
        clearanceType: 'Pre-Access',
        status: 'Cleared',
        requestedDate: '2026-06-15',
        processingDays: 2,
      },
      {
        id: 'PC-3309',
        participant: 'F. Okafor',
        company: 'Prairie Rail Co',
        clearanceType: 'Site Entry',
        status: 'Cleared',
        requestedDate: '2026-06-16',
        processingDays: 3,
      },
      {
        id: 'PC-3310',
        participant: 'E. Sokolov',
        company: 'TransWest Logistics',
        clearanceType: 'Pre-Access',
        status: 'Expired',
        requestedDate: '2026-06-18',
        processingDays: 8,
      },
      {
        id: 'PC-3311',
        participant: 'B. Martineau',
        company: 'Northbridge Energy',
        clearanceType: 'Site Entry',
        status: 'Cleared',
        requestedDate: '2026-06-22',
        processingDays: 1,
      },
      {
        id: 'PC-3312',
        participant: 'T. Abernathy',
        company: 'Cascade Constructors',
        clearanceType: 'Pre-Access',
        status: 'Pending',
        requestedDate: '2026-06-24',
        processingDays: 4,
      },
      {
        id: 'PC-3313',
        participant: 'V. Nakamura',
        company: 'Summit Mining Group',
        clearanceType: 'Return to Duty',
        status: 'Cleared',
        requestedDate: '2026-06-25',
        processingDays: 3,
      },
      {
        id: 'PC-3314',
        participant: 'I. MacPherson',
        company: 'Northbridge Energy',
        clearanceType: 'Pre-Access',
        status: 'Cleared',
        requestedDate: '2026-06-29',
        processingDays: 2,
      },
      {
        id: 'PC-3315',
        participant: 'Z. Grewal',
        company: 'Summit Mining Group',
        clearanceType: 'Site Entry',
        status: 'Pending',
        requestedDate: '2026-07-03',
        processingDays: 2,
      },
    ],
  },
]

export function getDataset(id: string): Dataset | undefined {
  return datasets.find((d) => d.id === id)
}
